import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';
import { FilterOperationType, type IFilter } from '@chax-at/prisma-filter-common';
import type { ISchoolClassFilter } from 'common/interface/filter.interface';

export async function fetchSchoolClasses(): Promise<Components.Schemas.SchoolClassDto[]> {
  const filter: IFilter<ISchoolClassFilter> = {
    filter: [{ field: 'isTemplate', type: FilterOperationType.Eq, value: false }],
    order: [{ field: 'name', dir: 'asc' }],
  };
  const result = await Api.Routes.SchoolClass.retrieve({ $filter: filter });
  return result.rows;
}

export async function createSchoolClass(
  dto: Components.Schemas.CreateSchoolClassDto,
): Promise<Components.Schemas.SchoolClassDto> {
  const result = await Api.Routes.SchoolClass.create(null, dto);
  return result.data;
}

export async function createSchoolClassSetup(
  dto: Components.Schemas.CreateSchoolClassSetupDto,
): Promise<Components.Schemas.SchoolClassSetupResponseDto> {
  return Api.Routes.SchoolClass.createSetup(null, dto);
}

export async function updateSchoolClass(params: {
  schoolClassId: number;
  dto: Components.Schemas.UpdateSchoolClassDto;
}): Promise<void> {
  await Api.Routes.SchoolClass.update({ id: params.schoolClassId }, params.dto);
}

export async function deleteSchoolClass(params: { schoolClassId: number }): Promise<void> {
  await Api.Routes.SchoolClass.delete({ id: params.schoolClassId });
}

export async function dismissSchoolYearOverBanner(params: { schoolClassId: number }): Promise<void> {
  await Api.Routes.SchoolClass.dismissSchoolYearOverBanner({ id: params.schoolClassId });
}

export async function archiveSchoolClass(params: { schoolClassId: number; finalNote: string }): Promise<void> {
  await Api.Routes.SchoolClass.archive({ id: params.schoolClassId }, { finalNote: params.finalNote });
}

export async function setBaseClass(params: {
  schoolClassId: number;
  dto: Components.Schemas.SetBaseClassDto;
}): Promise<void> {
  await Api.Routes.SchoolClass.setBaseClass({ id: params.schoolClassId }, params.dto);
}
